import { render, staticRenderFns } from "./point-regist.vue?vue&type=template&id=1ce1892a&scoped=true&"
import script from "./point-regist.vue?vue&type=script&lang=js&"
export * from "./point-regist.vue?vue&type=script&lang=js&"
import style0 from "./point-regist.vue?vue&type=style&index=0&id=1ce1892a&prod&scoped=true&lang=css&"
import style1 from "./point-regist.vue?vue&type=style&index=1&id=1ce1892a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1892a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContent,VImg,VOverlay,VProgressCircular,VRow,VTextField})
